import gsap from "gsap";

document.addEventListener('alpine:init', () => {

  //
  //  Panel Store
  //

  Alpine.store('panels', {
    states: {},

    open(id) {
      this.states[id] = true
      document.body.classList.add('overflow-hidden')
    },

    close(id) {
      this.states[id] = false
      document.body.classList.remove('overflow-hidden')
    },

    toggle(id) {
      this.states[id] = !this.states[id]
      if( this.isOpen(id)) {
        this.open(id)
      } else {
        this.close(id);
      }
    },

    // isDirty(id) {
    //   return !(this.states[id] === undefined);
    // },

    isOpen(id) {
      return !!this.states[id]
    }
  })

  //
  //  Panel Animation
  //

  Alpine.data('panelAnimation', ($id, $el) => ({
    id: $id,
    el: $el,

    init() {
      this.$watch('$store.panels.states', () => {
        if (this.$store.panels.isOpen(this.id)) {
          this.animateIn();
        } else {
          this.animateOut();
        }
      });
    },

    animateIn() {
      const anchors = this.el.querySelectorAll('li a, div a');

      gsap.killTweensOf(anchors);

      anchors.forEach((a) => {
        const parent = a.closest('li, div');
        if (parent) parent.style.overflow = 'hidden';
      });

      gsap.set(anchors, {
        display: 'inline-block',
        y: 30,
        opacity: 0
      });

      gsap.to(anchors, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        stagger: 0.1,
        overwrite: 'auto',
        ease: 'expo.inOut',
        immediateRender: false,
      });
    },

    animateOut() {
      const anchors = this.el.querySelectorAll('li a, div a');
      gsap.killTweensOf(anchors);
      gsap.to(anchors, {
        opacity: 0,
        duration: 0.3,
        ease: 'expo.inOut',
        overwrite: 'auto',
        immediateRender: false,
      });
    }
  }));


})